module.exports = __webpack_public_path__ + "static/harbinger-of-dawn-5719c4b503a4ec241134092c828a2741.png";